import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MH_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#MH_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#3D58DB"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MH_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#MH_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 11l-.817 2.944.008-3.055-1.581 2.614.831-2.94-2.228 2.091 1.594-2.606-2.709 1.412 2.238-2.08-2.99.63 2.717-1.4-3.049-.2 2.993-.615L2.126 6.78l3.047.216-2.5-1.755 2.876 1.03-1.934-2.365 2.492 1.768-1.224-2.8 1.922 2.375-.424-3.026 1.21 2.806L8 2l.409 3.028 1.21-2.805-.424 3.025 1.922-2.375-1.224 2.8 2.492-1.768-1.934 2.365 2.876-1.03-2.5 1.755 3.047-.216-2.881 1.016 2.993.614-3.049.201 2.717 1.4-2.99-.63 2.238 2.08-2.71-1.412 1.595 2.606-2.228-2.09.831 2.94-1.58-2.615.007 3.055L8 11z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M-.781 24.745l34.04-23.53v7.67l-34.04 15.86z", fill: "#fff" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-.781 24.745l34.04-29.53v7.67l-34.04 21.86z",
      fill: "#E2AE57"
    }
  )))
), a = t;
export {
  a as default
};
